import React from "react";
import { Pie, PieChart, Cell, Label, Tooltip } from "recharts";

type Prop = {
  name: string;
  value: number;
};

type PieChartProp = {
  data?: Prop[];
  PIE_COLORS: string[];
};

function PieCharts({ data = [], PIE_COLORS }: PieChartProp) {
  // Default categories if no data is provided
  const defaultCategories = [
    { name: "Immediate", value: 0 },
    { name: "Scheduled", value: 0 },
  ];

  // Ensure chartData always has required categories
  const chartData = data.length ? data : defaultCategories;

  // Calculate total value
  const totalValue = chartData.reduce((acc, curr) => acc + curr.value, 0);

  // Define colors for slices

  // Format total value
  const formattedTotalValue =
    totalValue >= 1000
      ? (totalValue / 1000).toFixed(1) + "k"
      : totalValue.toString();

  return (
    <div>
      <PieChart width={234} height={234}>
        {/* Show a 'No Data' Pie if totalValue is 0 */}
        {totalValue === 0 ? (
          <Pie
            data={[{ name: "No Data", value: 1 }]}
            dataKey="value"
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={80}
            fill="#d52b1e"
          >
            <Label
              value="No Data"
              position="center"
              fontSize={18}
              style={{ fontWeight: "bold", fill: "#666" }}
            />
          </Pie>
        ) : (
          <Pie
            data={chartData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={50}
            outerRadius={80}
            fill="#8884d8"
          >
            {chartData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={
                  totalValue === 0
                    ? "#E5E7EB" // No Data gray
                    : PIE_COLORS[index % PIE_COLORS.length]
                }
              />
            ))}
            <Label
              value={formattedTotalValue}
              position="center"
              fontSize={24}
              style={{ fontWeight: "bold" }}
            />
          </Pie>
        )}
        <Tooltip />
      </PieChart>
    </div>
  );
}

export default PieCharts;
